import { Link } from "react-router-dom";
import type { PlotItem } from "@/types/content";

export default function PlotCard({ item }: { item: PlotItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 10" }}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 我的朋友他的妻子剧情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500/90 px-2 py-1 text-xs font-medium text-background-50">
          {item.chapter}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}